import { API_URL } from "../../constants";
import { axiosInstance } from "../_base/axios.instance";

export async function removePost({ postId }){
    const response = await axiosInstance.delete(
        `${API_URL}/posts/delete/${postId}`,
        {}
      );
      return response;
}